export const BASE_URL = process.env.REACT_APP_API_URL || '/';
export const TIMEOUT_PERIOD = 200000;
